import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Carousel from '../../helpers/carousel';
import Card from '../../helpers/card';

// Import slider images
import slider1 from '../../assets/images/slider-1.cddf43e1.jpg';
import slider2 from '../../assets/images/slider-2.3e37db0c.jpg';
import slider3 from '../../assets/images/slider-3.5e90dc7d.jpg';
import slider4 from '../../assets/images/slider-4.28289ff0.jpg';

// Import cause images
import girlImage from '../../assets/images/girl-386X294.219e5b32.jpg';
import boyImage from '../../assets/images/boy-386X294.950f252c.jpg';
import communityImage from '../../assets/images/community-386X294.7f0f0ac1.jpg';
import experience from '../../assets/images/blessingministryhomeboyd-1.1fb04759.png';

// Import difference section images
import churchConstruction from '../../assets/images/churchConstruction-700X500.9f2b4c73.jpg';
import churchEeuca from '../../assets/images/churchEeuca-700X500.45baccf3.jpg';
import schoolEeuca from '../../assets/images/schoolEeuca-700X500.deafce96.jpg';
import schoolGroup from '../../assets/images/schoolGroupEeuca-700X500.d1a2258d.jpg';
import helpingHand from '../../assets/images/helpingHand.08730065.jpeg';

const Home = () => {
  const { t } = useTranslation();

  const sliderItems = [
    {
      image: slider1,
      alt: t('home_page.slider1.alt'),
      caption: (
        <>
          <h3>{t('home_page.slider1.caption_header')}</h3>
          <p>{t('home_page.slider1.caption_body')}</p>
        </>
      )
    },
    {
      image: slider2,
      alt: t('home_page.slider2.alt'),
      caption: (
        <>
          <h3>{t('home_page.slider2.caption_header')}</h3>
          <p>{t('home_page.slider2.caption_body')}</p>
        </>
      )
    },
    {
      image: slider3,
      alt: t('home_page.slider3.alt'),
      caption: (
        <>
          <h3>{t('home_page.slider3.caption_header')}</h3>
          <p>{t('home_page.slider3.caption_body')}</p>
        </>
      )
    },
    {
      image: slider4,
      alt: 'Blessing Homes Ministry',
      caption: (
        <>
          <h3>Welcome to EUCA Church</h3>
          <p>Join us in making a difference</p>
        </>
      )
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Slider */}
      <Carousel items={sliderItems} interval={5000} autoPlay={true} />

      {/* About Section */}
      <Container className="my-5">
        <Row className="align-items-center">
            <Col lg={6}>
                <img
                    src={experience}
                    alt="Helping Hand"
                    className="img-fluid rounded shadow"
                />
            </Col>
            <Col lg={6}>
            <h4 className={'pb-4'}>{t('home_page.about_us.about_us')}</h4>
            <h2 className={'pb-4'}><strong>{t('home_page.about_us.our_mision')}</strong></h2>
            <p>{t('home_page.about_us.our_mission_description')}</p>
            <Button variant="primary" href="/about">
              {t('home_page.about_us.button')}
            </Button>
          </Col>
        </Row>
      </Container>

      {/* Causes Section */}
      <section className="causes-section bg-light py-5">
        <Container>
          <div className="text-center mb-4">
            <h2>{t('home_page.causes.title')}</h2>
            <p>{t('home_page.causes.description')}</p>
          </div>
          <Row>
            <Col md={4} className="mb-4">
              <Card
                image={girlImage}
                title={t('home_page.causes.cards.one.title')}
                body={t('home_page.causes.cards.one.body')}
                buttonText={t('home_page.causes.cards.one.button')}
                buttonLink="/causes"
              />
            </Col>
            <Col md={4} className="mb-4">
              <Card className={'align-items-center'}
                image={boyImage}
                title={t('home_page.causes.cards.two.title')}
                body={t('home_page.causes.cards.two.body')}
                buttonText={t('home_page.causes.cards.two.button')}
                buttonLink="/causes"
              />
            </Col>
            <Col md={4} className="mb-4">
              <Card
                image={communityImage}
                title={t('home_page.causes.cards.three.title')}
                body={t('home_page.causes.cards.three.body')}
                buttonText={t('home_page.causes.cards.three.button')}
                buttonLink="/causes"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* How We Make a Difference */}
      <Container className="my-5">
        <h2 className="text-center mb-4">{t('home_page.difference.first_section.title')}</h2>
        <Row className="mb-4">
          <Col md={6} className="mb-3">
            <img src={churchConstruction} alt="Church Construction" className="img-fluid rounded" />
          </Col>
          <Col md={6} className="mb-3">
            <img src={churchEeuca} alt="EUCA Church" className="img-fluid rounded" />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <img src={schoolEeuca} alt="School" className="img-fluid rounded" />
          </Col>
          <Col md={6} className="mb-3">
            <img src={schoolGroup} alt="School Group" className="img-fluid rounded" />
          </Col>
        </Row>
      </Container>

      {/* How You Can Help */}
      <section className="help-section bg-primary text-white py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <img src={helpingHand} alt="Helping Hand" className="img-fluid rounded" />
            </Col>
            <Col lg={6}>
              <h2>{t('home_page.difference.second_section.title')}</h2>
              <p>{t('home_page.difference.second_section.description')}</p>
              <Button variant="light" size="lg" href="/donate">
                {t('home_page.difference.second_section.button')}
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
